import { z } from "zod";

type ConstEnum<Enum extends string> = { [key: string]: Enum };

export const productRelationSchema = z.enum([
  "standard",
  "variant",
  "Recipe in booklet",
  "Yarn in recipe"
]);

export type ProductRelation = z.infer<typeof productRelationSchema>;
export const ProductRelation = {
  Standard: "standard",
  Variant: "variant",
  RecipeInBooklet: "Recipe in booklet",
  YarnInRecipe: "Yarn in recipe"
} satisfies ConstEnum<ProductRelation>;

export const productTypeSchema = z.enum([
  "yarn",
  "accessory",
  "booklet",
  "recipe"
]);

type ProductType = z.infer<typeof productTypeSchema>;
export const ProductType = {
  Yarn: "yarn",
  Accessory: "accessory",
  Booklet: "booklet",
  Recipe: "recipe"
} satisfies ConstEnum<ProductType>;
